import { getTopProviders } from 'api/ppaOnboarding';
import { useCallback, useEffect, useState } from 'react';

const useGetPPATopProviders = (): [any | undefined, boolean, string, () => Promise<void>] => {
    const [data, setData] = useState<any | undefined>();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<string>('');

    const fetch = useCallback(async () => {
        try {
            setLoading(true);
            const res = await getTopProviders();
            if (res && !res.error) {
                setData(res.data?.data);
            } else {
                setError(res?.error);
            }
        } catch (e) {
            console.error(e);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => {
        fetch();
    }, [fetch]);

    return [data, loading, error, fetch];
};

export default useGetPPATopProviders;
